/**
 * Triggers a browser download of a Blob via a temporary anchor element.
 * @param {Blob} blob - The file contents.
 * @param {string} filename - The filename to save as.
 * @returns {void}
 */
export function downloadBlob(blob, filename) {
	const url = URL.createObjectURL(blob);
	const link = document.createElement('a');
	try {
		link.href = url;
		link.download = filename;
		link.style.display = 'none';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	} finally {
		URL.revokeObjectURL(url);
	}
}
